export default "__VITE_ASSET__DPSBJKGV__"